import { themeGet } from '@styled-system/theme-get'
import styled, { css } from 'styled-components'
import {
  space,
  SpaceProps,
  typography,
  TypographyProps,
  grid,
  GridProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  color,
  ColorProps,
  flexbox,
  FlexboxProps,
  flexGrow,
  FlexGrowProps,
  flex,
  FlexProps,
  border,
  BorderProps,
} from 'styled-system'
import { ifProp, switchProp } from 'styled-tools'

interface BoxProps
  extends ColorProps,
    PositionProps,
    SpaceProps,
    TypographyProps,
    GridProps,
    LayoutProps,
    PositionProps,
    ColorProps,
    FlexboxProps,
    FlexGrowProps,
    ColorProps,
    FlexProps,
    BorderProps {
  link?: boolean
}

export const Box = styled.div<BoxProps>`
  ${space}
  ${typography}
  ${grid}
  ${layout}
  ${position}
  ${color}
  ${flexbox}
  ${border}

  ${({ link }) =>
    link &&
    `
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.2s;
    &:hover {
      background: rgba(0, 0, 0, 0.1);
    }
  `}
`

export const WarningBox = styled.div`
  background-color: ${themeGet('colors.warning-background')};
  border-radius: ${themeGet('radii.medium')};
  padding: 20px;
  display: flex;
  gap: 15px;
  align-items: center;
  color: ${themeGet('colors.accent4')};
  ${flexGrow}
  ${flex}
  ${border}
`

export const NoticeBox = styled.div<
  SpaceProps & ColorProps & { variant?: 'info' | 'success' | 'warning' }
>`
  background-color: ${switchProp(
    'variant',
    {
      info: css`
        ${themeGet('colors.tip-box-bg')}
      `,
      success: css`
        ${themeGet('colors.success-background')}
      `,
      warning: css`
        ${themeGet('colors.warning-background')}
      `,
    },
    css`
      ${themeGet('colors.success-background')}
    `,
  )};

  padding: ${themeGet('space.medium')};
  border-radius: ${themeGet('radii.medium')};
  color: ${themeGet('colors.text')};
  display: flex;
  gap: ${themeGet('space.small')};
  align-items: center;

  ${space}
  ${color}
`

interface FilterBoxProps extends FlexboxProps, PositionProps, SpaceProps, LayoutProps {
  border?: boolean
}

export const FilterBox = styled.div<FilterBoxProps>`
  display: flex;
  flex-direction: column;
  gap: ${themeGet('space.medium')};
  border-radius: ${themeGet('radii.medium')};
  padding-bottom: 10px;

  ${ifProp(
    'border',
    css`
      border: 1px solid ${themeGet('colors.border-color')};
    `,
  )};

  ${flexbox}
  ${position}
  ${space}
  ${layout}
`

export const FilterItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  font-weight: 600;
  font-size: 14px;
  max-width: 300px;
`

export const InfoBox = styled.div`
  display: flex;
  gap: 40px;
  font-weight: 700;
  font-size: 15px;
  color: ${themeGet('colors.text')};
  background: ${themeGet('colors.background')};
  padding-bottom: 20px;
  margin-top: 25px;
  position: sticky;
  top: 68px;
`

export const DangerBox = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  border: 1px solid red;
  padding: 15px;
`
